export const NATURE_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Ванная комната в сочетании оттенков природы',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-v-sochetanii-ottenkov-prirody',
    style: 'nature',
  },
  {
    displayedName: 'Эко-дизайн для малогабаритной ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg'],
    productName: 'eko-dizayn-dlya-malogabaritnoy-vannoy-komnaty',
    style: 'nature',
  },
  {
    displayedName: 'В ванной комнате всё поместится',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'v-vannoy-komnate-vse-pomestitsya',
    style: 'nature',
  },
  {
    displayedName: 'Ванная комната с экзотическими акцентами',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-s-ekzoticheskimi-akcentami',
    style: 'nature',
  },
  {
    displayedName: 'Ванная комната из контрастов и цветовых пятен',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-iz-kontrastov-i-cvetovyh-pyaten',
    style: 'nature',
  },
  {
    displayedName: 'Бамбук на акцентной стене в ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'bambuk-na-akcentnoy-stene-v-vannoy',
    style: 'nature',
  },
  {
    displayedName: 'Скандинавский стиль ванной в пастельных тонах',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'skandinavskiy-stil-vannoy-v-pastelnyh-tonah',
    style: 'nature',
  },
  {
    displayedName: 'Встраиваемая сантехника в проекте ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg'],
    productName: 'vstraivaemaya-santehnika-v-proekte-vannoy-komnaty',
    style: 'nature',
  },
  {
    displayedName: 'Бережно к людям, бережно к природе',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'berezhno-k-lyudyam-berezhno-k-prirode',
    style: 'nature',
  },
  {
    displayedName: 'Плавные сочетания элементов в стиле лофт для ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'plavnye-sochetaniya-elementov-v-stile-loft-dlya-vannoy-komnaty',
    style: 'nature',
  },
  {
    displayedName: 'Стильная душевая перегородка в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'stilnaya-dushevaya-peregorodka-v-vannoy-komnate',
    rating: 1005,
    style: 'nature',
  },
  {
    displayedName: 'Ванная комната с восточным акцентом',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'vannaya-komnata-s-vostochnym-akcentom',
    style: 'nature',
  },
  {
    displayedName: 'Порядок в ванной с подвесной мебелью',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'poryadok-v-vannoy-s-podvesnoy-mebelyu',
    style: 'nature',
  },
  {
    displayedName: 'В ванной комнате с заботой о близких',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'v-vannoy-komnate-s-zabotoy-o-blizkih',
    style: 'nature',
  },
  {
    displayedName: 'Небольшая ванная комната с характером',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'nebolshaya-vannaya-komnata-s-harakterom',
    style: 'nature',
  },
  {
    displayedName: 'Тёмные линии в небольшой ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'temnye-linii-v-nebolshoy-vannoy',
    style: 'nature',
  },
];
